import { Box } from '@mui/material';
import { FunctionComponent } from 'react';

export const DrawerActions: FunctionComponent<
    React.PropsWithChildren<unknown>
> = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                mt: 6,
                p: 4,
            }}
        >
            {children}
        </Box>
    );
};
